//// Neoffice — the catalogue's toggles last for the visit, not for ever (2026-09-14). They
//// lived in localStorage: a toggle ticked once greeted every later visit with a filtered
//// catalogue, the "Clear all" of a filter nobody remembered and, on a shop without any
//// discounted product, an empty grid. Session storage keeps them for the visit (a product
//// page and back), a toggle the page does not offer (no discounted product, no used unit)
//// is never on, and the old permanent copies are dropped.
webshop.filter_store = {
	keys: ["discount_filter_checked", "second_hand_filter_checked", "stock_filter_checked"],
	offered(key) {
		if (key === "discount_filter_checked") return window.discount_count !== 0;
		if (key === "second_hand_filter_checked") return window.second_hand_count !== 0;
		return true;
	},
	get(key) {
		if (!this.offered(key)) return null;
		try { return sessionStorage.getItem(key); } catch (e) { return null; }
	},
	set(key, value) {
		try { sessionStorage.setItem(key, value); } catch (e) { /* storage blocked */ }
	},
	remove(key) {
		try { sessionStorage.removeItem(key); } catch (e) { /* storage blocked */ }
	},
	clear() {
		this.keys.forEach((key) => this.remove(key));
	},
};
try {
	webshop.filter_store.keys.forEach((key) => localStorage.removeItem(key));
} catch (e) { /* storage blocked */ }

webshop.ProductView =  class {
	/* Options:
		- View Type
		- Products Section Wrapper,
		- Item Group: If its an Item Group page
	*/
	constructor(options) {
		Object.assign(this, options);
		this.preference = this.view_type;
		//// Neoffice — added, down to load_settings below. ▼▼▼ Upstream's constructor
		//// just calls make(). Ours reads the shop's default view type from Webshop
		//// Settings (default_view_type) before rendering, honours the ?discount= and
		//// ?sort= parameters the carousels and the home page link to — storing them in
		//// localStorage and cleaning them off the URL so a refresh does not re-apply
		//// them — and keeps the buyer's own view/sort/filter preferences between visits
		//// (8ba1a7ab46, 2025-06-08; 3c1e847e26, 2025-06-24; 2591df1013, 2025-12-14). ▲▲▲
		this.total_product_count = null;  // Initialize to null to detect first load
		this.stock_filter_default = options.stock_filter_default || false;
		
		// Initialize sort order early
		this.current_sort = localStorage.getItem('product_sort_order') || 
			(window.product_settings && window.product_settings.default_product_sort) || 
			'relevance';
		
		// Check URL parameters for discount filter and sort order
		const urlParams = new URLSearchParams(window.location.search);
		
		// Handle discount filter from URL
		if (urlParams.get('discount') === 'true') {
			// Set discount filter in localStorage when coming from URL
			webshop.filter_store.set('discount_filter_checked', 'true'); //// Neoffice — visit-scoped (webshop.filter_store, 2026-09-14)
			// Also ensure stock filter is set to false if not already set
			if (webshop.filter_store.get('stock_filter_checked') === null) { //// Neoffice — visit-scoped (webshop.filter_store, 2026-09-14)
				webshop.filter_store.set('stock_filter_checked', 'false'); //// Neoffice — visit-scoped (webshop.filter_store, 2026-09-14)
			}
			// Remove the discount parameter from URL to avoid confusion
			urlParams.delete('discount');
		}
		
		// Handle sort order from URL
		if (urlParams.get('sort') === 'new_arrivals') {
			// Set sort order in localStorage when coming from URL
			localStorage.setItem('product_sort_order', 'new_arrivals');
			this.current_sort = 'new_arrivals';
			// Remove the sort parameter from URL to avoid confusion
			urlParams.delete('sort');
		}
		
		// Update URL if parameters were removed
		if (urlParams.get('discount') === null && urlParams.get('sort') === null) {
			const newUrl = window.location.pathname + (urlParams.toString() ? '?' + urlParams.toString() : '');
			window.history.replaceState({}, '', newUrl);
		}
		
		// Initialize stock filter preference if not set
		if (webshop.filter_store.get('stock_filter_checked') === null && webshop.filter_store.get('discount_filter_checked') === 'true') { //// Neoffice — visit-scoped (webshop.filter_store, 2026-09-14)
			// If discount filter is active and stock filter has no preference, set it to false
			webshop.filter_store.set('stock_filter_checked', 'false'); //// Neoffice — visit-scoped (webshop.filter_store, 2026-09-14)
		}
		
		this.load_settings();
		
		// Initialize preloaded results cache
		this.preloaded_discount_results = null;
		this.preload_in_progress = false;
	}

	load_settings() {
		frappe.call({
			method: 'webshop.webshop.doctype.webshop_settings.webshop_settings.get_shopping_cart_settings',
			callback: (r) => {
				if (r.message) {
					const savedView = localStorage.getItem("product_view");
					const defaultView = r.message.default_view_type;
					
					if (savedView) {
						this.preference = savedView;
					} else if (defaultView) {
						this.preference = defaultView + " View";
						localStorage.setItem("product_view", this.preference);
					} else {
						this.preference = "Grid View";
						localStorage.setItem("product_view", this.preference);
					}
					
					this.make();
				}
			}
		});
	}

	make(from_filters=false) {
		//// Neoffice — upstream empties the products section and rebuilds the toolbar on
		//// every call, so changing a filter blanked the page. The existing products stay
		//// on screen while the new ones load (51aab2af64, 2025-12-16), and the infinite
		//// scroll state is reset only when the filters actually changed (abea03c4d5).
		// Don't empty products_section immediately - keep existing products visible during loading
		// Only empty on initial load (when there are no products yet)
		const hasExistingProducts = $('#products-grid-area').length || $('#products-list-area').length;
		//// Neoffice — the first page rendered on the server (listing_ssr.html, #691 lot 2) is kept
		//// through the initial emptying and stays on screen, under the toolbar, until the script's
		//// own first result replaces it (drop_ssr_listing): no skeleton over cards already there.
		const ssr_listing = hasExistingProducts ? $() : this.products_section.children('.wsp-ssr-listing').detach();
		//// Neoffice — the sub-category pills drawn with the page (includes/sub_categories.html,
		//// #691 lot 2) are kept too, and go back in first place, above the toolbar.
		const sub_categories = hasExistingProducts ? $() : this.products_section.children('.sub-category-container').detach();

		if (!hasExistingProducts) {
			// Initial load - empty the section
			this.products_section.empty();
		}

		// Reset infinite scroll state when filters change or on initial load
		if (from_filters || !this.infinite_scroll_state) {
			this.infinite_scroll_state = null;
			if (this.infinite_scroll_observer) {
				this.infinite_scroll_observer.disconnect();
				this.infinite_scroll_observer = null;
			}
		}

		// Only prepare toolbar on initial load
		if (!hasExistingProducts) {
			//// Neoffice — see sub_categories above.
			this.products_section.append(sub_categories);
			this.prepare_toolbar();
		}
		//// Neoffice — see ssr_listing above.
		if (ssr_listing.length) {
			this.products_section.append(ssr_listing);
			this.ssr_listing = ssr_listing;
		}

		this.get_item_filter_data(from_filters);
	}

	//// Neoffice — added (#691 lot 2): the server's first page leaves when the script's first
	//// result arrives, and the view the visitor prefers shows (show_product_loader, which
	//// usually shows it, stood aside while the server's cards were on screen).
	drop_ssr_listing() {
		if (!this.ssr_listing) return;
		this.ssr_listing.remove();
		this.ssr_listing = null;
		const isGridView = this.preference === "Grid View";
		$('#products-grid-area').toggleClass('hidden', !isGridView);
		$('#products-list-area').toggleClass('hidden', isGridView);
	}

	//// Neoffice — added. The listing is also the search results page on our shops
	//// (/all-products?search=…), so the title, the breadcrumb and the search box have
	//// to say what was searched (912d29f1f4 / d579b1c02a, 2025-12-14).
	update_page_header_for_search() {
		// Update page header and breadcrumb when search term is present
		if (!this.search_term) return;

		const translations = window.product_translations || {};
		const searchLabel = translations["Search"] || "Search";
		const searchText = `${searchLabel}: "${this.search_term}"`;

		// Update main page header (first div inside .mb-6 header section)
		const $header = $('.mb-6.d-flex > div:first-child');
		if ($header.length && !$header.hasClass('search-updated')) {
			$header.text(searchText);
			$header.addClass('search-updated');
		}

		// Update document title
		document.title = searchText;

		// Update breadcrumb - add search item after Shop
		const $breadcrumbList = $('nav[aria-label="breadcrumb"] ol.breadcrumb');
		if ($breadcrumbList.length && !$breadcrumbList.hasClass('search-updated')) {
			// Add search breadcrumb item at the end
			const position = $breadcrumbList.find('li').length + 1;
			//// Neoffice — plain markup: the breadcrumb's structured data is the JSON-LD that
			//// breadcrumbs.html prints (#691); microdata added in the browser only confused it.
			$breadcrumbList.append(`
				<li class="breadcrumb-item active" aria-current="page">
					<span>${searchText}</span>
				</li>
			`);
			$breadcrumbList.addClass('search-updated');
		}

		// Pre-fill search box with search term
		const $searchBox = $('#search-box');
		if ($searchBox.length && !$searchBox.val()) {
			$searchBox.val(this.search_term);
		}

		// Also update the no-jquery search box if present
		const $searchBoxNoJq = $('#search-box-nojq');
		if ($searchBoxNoJq.length && !$searchBoxNoJq.val()) {
			$searchBoxNoJq.val(this.search_term);
		}
	}

	prepare_toolbar() {
		//// Neoffice — the toolbar stacks on mobile (upstream: one flex row, which crushed
		//// the search box and the sort selector under 768px).
		this.products_section.append(`
			<div class="toolbar d-flex flex-column flex-md-row align-items-center">
			</div>
		`);
		// On mobile: sort first, then search, then view toggles
		// On desktop: search, view toggles, sort
		this.prepare_search();
		this.prepare_view_toggler();
		//// Neoffice — two additions to the toolbar: the sort selector and the active-filter
		//// chips (see below).
		this.prepare_sort_selector();
		this.prepare_active_filters_display();

		new webshop.ProductSearch();
	}
	//// Neoffice — added, down to prepare_view_toggler. ▼▼▼ Upstream shows no trace of
	//// the filters in force: a buyer landing on a filtered listing (from a carousel,
	//// or after a reload) saw a short catalogue with no explanation. Every active
	//// filter — stock, discount, field, attribute, price — is rendered as a chip that
	//// removes it when clicked (8d180aac8b, 2025-12-14). The stock/discount chips
	//// target `input.stock-filter` / `input.discount-filter` directly because the
	//// class is on the input, not on a wrapper (ac1d09fbff, 2025-12-16). ▲▲▲
	
	prepare_active_filters_display() {
		// Add a section to show active filters
		//// Neoffice — the label was hard-coded English. A website page has no __()
		//// catalogue, so it printed "Active filters:" on a French shop right above chips
		//// that WERE translated; website pages read window.product_translations
		//// (CLAUDE.md, "Internationalization").
		const label = (window.product_translations || {})["Active filters:"] || "Active filters:";
		//// Neoffice — see the marker above: ${label} below renders the translated label;
		//// no comment fits closer, the line sits inside this template literal.
		//// Neoffice — pointer: the <small> three lines down prints ${label}, not the
		//// hard-coded "Active filters:" (2bafdf34c2 "fix(catalogue): la page « Catégories
		//// et marques » cesse de parler anglais").
		//// Neoffice — pointer can go no closer: the <small> that prints ${label} is
		//// 3 lines inside this template literal, past what a JS comment can reach
		//// (2bafdf34c2 "fix(catalogue): la page « Catégories et marques » cesse de
		//// parler anglais").
		//// Neoffice — pointer can go no closer: the <small> four lines down prints
		//// ${label}, the translated "Active filters:" (2bafdf34c2 "fix(catalogue): la
		//// page « Catégories et marques » cesse de parler anglais").
		//// Neoffice — pointer, tightest legal spot: the <small class="text-muted mr-2">
		//// three lines below this call prints ${label}, not the hard-coded English string;
		//// the line itself sits inside the template literal opened right here and cannot
		//// carry its own comment (2bafdf34c2 "fix(catalogue): la page « Catégories et
		//// marques » cesse de parler anglais").
		this.products_section.append(`
			<div class="active-filters-display mt-2 mb-2" style="display: none;">
				<div class="d-flex align-items-center flex-wrap" style="gap: 0.5rem;">
					<!-- //// Neoffice — prints the translated "Active filters:" label computed above, not the hard-coded English string (2bafdf34c2 "fix(catalogue): la page « Catégories et marques » cesse de parler anglais") -->
					<small class="text-muted mr-2">${label}</small>
					<div class="active-filter-badges d-flex flex-wrap" style="gap: 0.5rem;"></div>
				</div>
			</div>
		`);
	}
	
	update_active_filters_display() {
		const $display = $('.active-filters-display');
		const $badges = $('.active-filter-badges');
		$badges.empty();

		let hasActiveFilters = false;
		const self = this;

		// Check localStorage filters
		const stockFilter = webshop.filter_store.get('stock_filter_checked') === 'true'; //// Neoffice — visit-scoped (webshop.filter_store, 2026-09-14)
		const discountFilter = webshop.filter_store.get('discount_filter_checked') === 'true'; //// Neoffice — visit-scoped (webshop.filter_store, 2026-09-14)
		const translations = window.product_translations || {};

		if (stockFilter) {
			hasActiveFilters = true;
			$badges.append(`
				<span class="badge badge-info active-filter-badge" data-filter-type="stock" style="cursor: pointer;">
					<i class="fa fa-check"></i> ${translations["In Stock Only"] || "In Stock Only"}
					<i class="fa fa-times ml-1"></i>
				</span>
			`);
		}

		if (discountFilter) {
			hasActiveFilters = true;
			$badges.append(`
				<span class="badge badge-warning active-filter-badge" data-filter-type="discount" style="cursor: pointer;">
					<i class="fa fa-tag"></i> ${translations["Discounted Only"] || "Discounted Only"}
					<i class="fa fa-times ml-1"></i>
				</span>
			`);
		}
		//// Neoffice — the second-hand toggle's chip (2026-09-13)
		if (webshop.filter_store.get('second_hand_filter_checked') === 'true') { //// Neoffice — visit-scoped (webshop.filter_store, 2026-09-14)
			hasActiveFilters = true;
			$badges.append(`
				<span class="badge badge-dark active-filter-badge" data-filter-type="second_hand" style="cursor: pointer;">
					<i class="fa fa-recycle"></i> ${translations["Second-hand only"] || "Second-hand only"}
					<i class="fa fa-times ml-1"></i>
				</span>
			`);
		}

		// Parse URL filters (field_filters, attribute_filters)
		const urlParams = frappe.utils.get_query_params();

		// Field filters from URL
		if (urlParams.field_filters) {
			try {
				const fieldFilters = JSON.parse(decodeURIComponent(urlParams.field_filters));
				for (let fieldName in fieldFilters) {
					const values = fieldFilters[fieldName];
					if (Array.isArray(values)) {
						values.forEach(value => {
							hasActiveFilters = true;
							// Get display label from checkbox if available
							const $checkbox = $(`input[data-filter-name="${fieldName}"][data-filter-value="${value}"]`);
							//// Neoffice — the sidebar checkbox is the best label, but the facets are
							//// drawn asynchronously and a value whose facet has not rendered yet fell
							//// back to the value STORED on the item: a French shop showed the chip
							//// "Second-hand" next to a sidebar reading "Occasion". The catalogue's own
							//// translation table is the fallback now.
							const translated = translations[value] || value;
							const displayLabel = $checkbox.length ? $checkbox.next('label').text().trim() || translated : translated;
							$badges.append(`
								<span class="badge badge-secondary active-filter-badge" data-filter-type="field" data-filter-name="${fieldName}" data-filter-value="${value}" style="cursor: pointer;">
									${displayLabel}
									<i class="fa fa-times ml-1"></i>
								</span>
							`);
						});
					}
				}
			} catch (e) {
				console.error("Error parsing field_filters for display:", e);
			}
		}

		// Attribute filters from URL
		if (urlParams.attribute_filters) {
			try {
				const attrFilters = JSON.parse(decodeURIComponent(urlParams.attribute_filters));
				for (let attrName in attrFilters) {
					const values = attrFilters[attrName];
					if (Array.isArray(values)) {
						values.forEach(value => {
							hasActiveFilters = true;
							$badges.append(`
								<span class="badge badge-primary active-filter-badge" data-filter-type="attribute" data-filter-name="${attrName}" data-filter-value="${value}" style="cursor: pointer;">
									${attrName}: ${value}
									<i class="fa fa-times ml-1"></i>
								</span>
							`);
						});
					}
				}
			} catch (e) {
				console.error("Error parsing attribute_filters for display:", e);
			}
		}

		// Price range from URL
		if (urlParams.price_range) {
			try {
				const priceRange = JSON.parse(decodeURIComponent(urlParams.price_range));
				if (priceRange.min || priceRange.max) {
					hasActiveFilters = true;
					const minLabel = priceRange.min ? priceRange.min : '0';
					const maxLabel = priceRange.max ? priceRange.max : '∞';
					$badges.append(`
						<span class="badge badge-success active-filter-badge" data-filter-type="price" style="cursor: pointer;">
							<i class="fa fa-money"></i> ${minLabel} - ${maxLabel}
							<i class="fa fa-times ml-1"></i>
						</span>
					`);
				}
			} catch (e) {
				console.error("Error parsing price_range for display:", e);
			}
		}

		// Bind click handlers for removal
		$badges.find('.active-filter-badge').off('click').on('click', function() {
			self.remove_active_filter($(this));
		});

		// Show/hide the display based on active filters
		if (hasActiveFilters) {
			$display.show();
		} else {
			$display.hide();
		}
		//// Neoffice — "Clear all" only when there is something to clear, and the sidebar's
		//// counter only under a filter, with the listing's own figure (2026-09-14): both stood
		//// there at every load ("· 379 produits  Tout effacer"), which read as if filters were on.
		$('.clear-filters').toggleClass('d-none', !hasActiveFilters);
		const count = (this.total_count != null ? this.total_count : this.product_count) || 0;
		document.dispatchEvent(new CustomEvent('webshop:listing-count', { detail: { count: count, filtered: hasActiveFilters } }));
	}

	remove_active_filter($badge) {
		const filterType = $badge.data('filter-type');
		const filterName = $badge.data('filter-name');
		const filterValue = $badge.data('filter-value');

		if (filterType === 'stock') {
			// Remove stock filter
			webshop.filter_store.set('stock_filter_checked', 'false'); //// Neoffice — visit-scoped (webshop.filter_store, 2026-09-14)
			// The stock-filter class is ON the input itself, not a parent wrapper
			$('input.stock-filter').prop('checked', false);
			if (this.field_filters && this.field_filters['in_stock']) {
				delete this.field_filters['in_stock'];
			}
		} else if (filterType === 'discount') {
			// Remove discount filter
			webshop.filter_store.set('discount_filter_checked', 'false'); //// Neoffice — visit-scoped (webshop.filter_store, 2026-09-14)
			// The discount-filter class is ON the input itself, not a parent wrapper
			$('input.discount-filter').prop('checked', false);
			if (this.field_filters && this.field_filters['discount']) {
				delete this.field_filters['discount'];
			}
		} else if (filterType === 'second_hand') {
			//// Neoffice — the second-hand toggle's chip (2026-09-13)
			webshop.filter_store.set('second_hand_filter_checked', 'false'); //// Neoffice — visit-scoped (webshop.filter_store, 2026-09-14)
			$('input.second-hand-filter').prop('checked', false);
			if (this.field_filters && this.field_filters['second_hand']) {
				delete this.field_filters['second_hand'];
			}
		} else if (filterType === 'field') {
			// Remove field filter
			if (this.field_filters && this.field_filters[filterName]) {
				const idx = this.field_filters[filterName].indexOf(filterValue);
				if (idx > -1) {
					this.field_filters[filterName].splice(idx, 1);
				}
				if (this.field_filters[filterName].length === 0) {
					delete this.field_filters[filterName];
				}
			}
			// Uncheck the checkbox
			$(`input[data-filter-name="${filterName}"][data-filter-value="${filterValue}"]`).prop('checked', false);
		} else if (filterType === 'attribute') {
			// Remove attribute filter
			if (this.attribute_filters && this.attribute_filters[filterName]) {
				const idx = this.attribute_filters[filterName].indexOf(filterValue);
				if (idx > -1) {
					this.attribute_filters[filterName].splice(idx, 1);
				}
				if (this.attribute_filters[filterName].length === 0) {
					delete this.attribute_filters[filterName];
				}
			}
			// Uncheck the checkbox
			$(`input[data-attribute-name="${filterName}"][data-attribute-value="${filterValue}"]`).prop('checked', false);
		} else if (filterType === 'price') {
			// Clear price range
			this.price_range = {};
			$('#min-price').val('');
			$('#max-price').val('');
		}

		// Refresh products with updated filters
		this.from_filters = true;
		this.change_route_with_filters();
	}

	prepare_view_toggler() {

		//// Neoffice — upstream's second view is `#image-view`; ours is `#grid` (grid/list
		//// toggle rather than image/list). Same rename below in disable_view_toggler,
		//// render_view_toggler and set_view_state.
		if (!$("#list").length || !$("#grid").length) {
			this.render_view_toggler();
			this.bind_view_toggler_actions();
			this.set_view_state();
		}
	}
	//// Neoffice — added. Upstream offers no sorting at all: the listing comes back in
	//// the query's own order. Five orders, the default read from Webshop Settings
	//// (default_product_sort) and the choice kept in localStorage (3c1e847e26,
	//// 2025-06-24). Labels come from window.product_translations — this file is a
	//// bundle, so frappe's __() is not available to it (dd08553e88, 2025-12-15).
	
	prepare_sort_selector() {
		// Get saved sort order or use default from settings
		const saved_sort = localStorage.getItem('product_sort_order') || 
			(window.product_settings && window.product_settings.default_product_sort) || 
			'relevance';
		
		this.current_sort = saved_sort;
		
		// Use translations from window.product_translations
		const translations = window.product_translations || {};
		const sortByLabel = translations["Sort by:"] || "Sort by:";
		const mostRelevant = translations["Most Relevant"] || "Most Relevant";
		const priceLowToHigh = translations["Price: Low to High"] || "Price: Low to High";
		const priceHighToLow = translations["Price: High to Low"] || "Price: High to Low";
		const newArrivals = translations["New Arrivals"] || "New Arrivals";
		const customerRating = translations["Customer Rating"] || "Customer Rating";
		
		// Add sort selector to toolbar (not toggle-container)
		$(".toolbar").append(`
			<div class="sort-selector-container ml-md-auto d-flex align-items-center mb-2 mb-md-0">
				<label class="mb-0 mr-2 text-muted small d-none d-sm-block">${sortByLabel}</label>
				<div class="d-flex align-items-center">
					<svg class="icon icon-sm mr-1 d-sm-none text-muted" style="width: 16px; height: 16px;">
						<use href="#icon-sort"></use>
					</svg>
					<select class="form-control form-control-sm" id="product-sort-selector" style="width: auto; max-width: 200px;">
						<option value="relevance" ${saved_sort === 'relevance' ? 'selected' : ''}>${mostRelevant}</option>
						<option value="price_low_to_high" ${saved_sort === 'price_low_to_high' ? 'selected' : ''}>${priceLowToHigh}</option>
						<option value="price_high_to_low" ${saved_sort === 'price_high_to_low' ? 'selected' : ''}>${priceHighToLow}</option>
						<option value="new_arrivals" ${saved_sort === 'new_arrivals' ? 'selected' : ''}>${newArrivals}</option>
						<option value="rating" ${saved_sort === 'rating' ? 'selected' : ''}>${customerRating}</option>
					</select>
				</div>
			</div>
		`);
		
		// Bind change event
		$('#product-sort-selector').on('change', (e) => {
			const new_sort = $(e.target).val();
			this.current_sort = new_sort;
			
			// Save preference
			localStorage.setItem('product_sort_order', new_sort);
			
			// Reload products with new sort
			this.get_item_filter_data(true);
		});
	}

	get_item_filter_data(from_filters=false) {
		// Get and render all Product related views
		let me = this;
		this.from_filters = from_filters;
		let args = this.get_query_filters();

		//// Neoffice — the header/breadcrumb are updated on each query, not only on load.
		// Update page header for search (if search term present)
		this.update_page_header_for_search();

		this.disable_view_toggler(true);
		//// Neoffice — upstream has no loading state. A skeleton is shown instead of
		//// blanking the list (567e038dd5, 2025-12-16).
		this.show_product_loader();

		frappe.call({
			method: "webshop.webshop.api.get_product_filter_data",
			args: {
				query_args: args
			},
			callback: function(result) {
				//// Neoffice — the script's result replaces the server's first page (#691 lot 2)
				me.drop_ssr_listing();
				if (!result || result.exc || !result.message || result.message.exc) {
					//// Neoffice — the loader must be hidden on the error path too, or a failed query
					//// left the skeleton spinning for ever.
					me.hide_product_loader();
					me.render_no_products_section(true);
				//// Neoffice — trailing whitespace only.
				} else {					
					// Sub Category results are independent of Items
					//// Neoffice — upstream reads result.message["sub_categories"].length without
					//// checking the key exists; the API omits it entirely when there are none.
					if (me.item_group && result.message["sub_categories"] && result.message["sub_categories"].length) {
						me.render_item_sub_categories(result.message["sub_categories"]);
					}

					//// Neoffice — the discount filter and the price range are rebuilt on every result
					//// (upstream only builds them from the first response, so the price slider kept
					//// the bounds of the unfiltered catalogue), and any leftover "no products"
					//// message is removed before rendering (8ba1a7ab46, 2025-06-08).
					// Always render discount filters
					me.re_render_discount_filters();
					
					// Update price filter range if available
					if (result.message.filters && result.message.filters.price_filters) {
						me.update_price_filter_range(result.message.filters.price_filters);
					} 

					// Clean up any existing no-products section before rendering
					$('.cart-empty').remove();
					
					if (!result.message["items"].length) {
						// if result has no items or result is empty
						//// Neoffice — hide the skeleton before showing the empty state.
						me.hide_product_loader();
						//// Neoffice — and the previous result's tiles go (2026-09-14): they stayed on
						//// screen above "no products found", as if the filter had kept them.
						$('#products-grid-area, #products-list-area').empty();
						me.products = null;
						me.product_count = 0;
						me.total_count = 0;
						me.render_no_products_section();
					} else {
						//// Neoffice — the results are stored on the view BEFORE rendering, because the
						//// infinite scroll and the live counter read them afterwards; upstream stores
						//// them after the render.
						// Store products before rendering
						me.products = result.message["items"];
						me.product_count = result.message["items_count"];
						me.total_count = result.message["total_count"];  // Utilisation du nouveau total
						me.settings = result.message["settings"];  // Store settings for later use
						
						// Hide loader after storing products
						me.hide_product_loader();
						
						// Render views
						me.render_list_view(result.message["items"], result.message["settings"]);
						me.render_grid_view(result.message["items"], result.message["settings"]);

						//// Neoffice — the catalogue's total is remembered from the first load, so the
						//// counter can say "12 of 340" once a filter is applied.
						// Store total product count on first load
						if (me.total_product_count === null) {
							me.total_product_count = result.message.total_products || me.product_count;
						}
					}

					// Bind filter actions
					if (!from_filters) {
						// If `get_product_filter_data` was triggered after checking a filter,
						// don't touch filters unnecessarily, only data must change
						// filter persistence is handle on filter change event
						me.bind_filters();
						me.restore_filters_state();
					//// Neoffice — the discount checkbox is restored from localStorage on every render:
					//// it is not a URL filter, so a re-render otherwise showed it unchecked while the
					//// filter was still applied.
					} else {
						// Always restore discount checkbox state from localStorage
						const saved_discount_preference = webshop.filter_store.get('discount_filter_checked'); //// Neoffice — visit-scoped (webshop.filter_store, 2026-09-14)
						if (saved_discount_preference !== null) {
							$('#showDiscountOnly').prop('checked', saved_discount_preference === 'true');
						}
					}

					// Bottom paging
					me.add_paging_section(result.message["settings"]);
					//// Neoffice — refresh the active-filter chips after each result.
					
					// Update active filters display
					me.update_active_filters_display();
				}

				me.disable_view_toggler(false);
			}
		});
	}

	disable_view_toggler(disable=false) {
		$('#list').prop('disabled', disable);
		//// Neoffice — `#image-view` → `#grid`, see prepare_view_toggler above.
		$('#grid').prop('disabled', disable);
	}

	render_grid_view(items, settings) {
		// loop over data and add grid html to it
		let me = this;

		this.prepare_product_area_wrapper("grid");

		new webshop.ProductGrid({
			items: items,
			products_section: $("#products-grid-area"),
			settings: settings,
			preference: me.preference
		});
	}

	render_list_view(items, settings) {
		let me = this;

		this.prepare_product_area_wrapper("list");

		new webshop.ProductList({
			items: items,
			products_section: $("#products-list-area"),
			settings: settings,
			preference: me.preference
		});
	}

	prepare_product_area_wrapper(view) {
		//// Neoffice — reuse the existing area instead of appending a second one: with the
		//// products kept on screen during loading, appending created a duplicate
		//// #products-grid-area and the page showed the catalogue twice (abea03c4d5,
		//// 2025-12-16).
		// Check if the area already exists - if so, just clear it and return
		const existingArea = $(`#products-${view}-area`);
		if (existingArea.length) {
			existingArea.empty();
			return existingArea;
		}

		// Create new area only if it doesn't exist
		let left_margin = view == "list" ? "ml-2" : "";
		//// Neoffice — mt-6 → mt-2: the toolbar above is now two rows on mobile.
		let top_margin = view == "list" ? "mt-2" : "mt-minus-1";
		//// Neoffice — upstream emits a <br> before the product area; dropped with the
		//// toolbar rework.
		//// Neoffice — no itemscope on the grid: a list of products is not "a Product" (#691, D4).
		return this.products_section.append(`
			<div id="products-${view}-area" class="row products-list ${ top_margin } ${ left_margin }"></div>
		`);
	}

	get_query_filters() {
		const filters = frappe.utils.get_query_params();
		//// Neoffice — added, down to the end of get_query_filters. ▼▼▼ Three things
		//// upstream does not do: it reads a price_range filter (6fea19b1fe, 2025-06-17);
		//// it parses the JSON filters defensively — a filter URL shared from a phone
		//// arrives double-encoded and upstream's bare JSON.parse threw, leaving the
		//// listing empty with only a console error; and the stock/discount filters are
		//// read from localStorage, not from the URL, because they are a per-visitor
		//// preference rather than a shareable filter (8ba1a7ab46, 2025-06-08). ▲▲▲
		let {field_filters, attribute_filters, price_range} = filters;

		// Safe parsing with proper decoding for mobile compatibility
		try {
			field_filters = field_filters ? JSON.parse(decodeURIComponent(field_filters)) : {};
		} catch (e) {
			console.error("Error parsing field_filters:", e);
			// Try without decoding as fallback
			try {
				field_filters = field_filters ? JSON.parse(field_filters) : {};
			} catch (e2) {
				console.error("Error parsing field_filters (fallback):", e2);
				field_filters = {};
			}
		}
		
		try {
			attribute_filters = attribute_filters ? JSON.parse(decodeURIComponent(attribute_filters)) : {};
		} catch (e) {
			console.error("Error parsing attribute_filters:", e);
			// Try without decoding as fallback
			try {
				attribute_filters = attribute_filters ? JSON.parse(attribute_filters) : {};
			} catch (e2) {
				console.error("Error parsing attribute_filters (fallback):", e2);
				attribute_filters = {};
			}
		}
		
		// Always check localStorage for stock/discount filters
		// These are managed separately from URL filters
		const saved_stock_preference = webshop.filter_store.get('stock_filter_checked'); //// Neoffice — visit-scoped (webshop.filter_store, 2026-09-14)
		const saved_discount_preference = webshop.filter_store.get('discount_filter_checked'); //// Neoffice — visit-scoped (webshop.filter_store, 2026-09-14)
		
		// For stock filter
		if (saved_stock_preference !== null) {
			if (saved_stock_preference === 'true') {
				field_filters["in_stock"] = ["1"];
			}
		} else if (Object.keys(field_filters).length === 0 && !this.from_filters && saved_discount_preference !== 'true') {
			// Only apply default if no saved preference, no other filters active, and discount is not active
			if (this.stock_filter_default) {
				field_filters["in_stock"] = ["1"];
			}
		}
		
		// For discount filter - always respect localStorage
		if (saved_discount_preference === 'true') {
			field_filters["discount"] = ["100"];
		}
		//// Neoffice — the second-hand toggle, a per-visitor preference like the two above
		if (webshop.filter_store.get('second_hand_filter_checked') === 'true') { //// Neoffice — visit-scoped (webshop.filter_store, 2026-09-14)
			field_filters["second_hand"] = ["1"];
		}
		
		// Retrieve the price_range parameter from the URL
		if (price_range) {
			try {
				this.price_range = JSON.parse(decodeURIComponent(price_range));
			} catch (e) {
				console.error("Error parsing price_range parameter:", e);
				// Try without decoding as fallback
				try {
					this.price_range = JSON.parse(price_range);
				} catch (e2) {
					console.error("Error parsing price_range (fallback):", e2);
					this.price_range = {};
				}
			}
		}

		// Get search parameter from URL
		const search = filters.search || null;

		//// Neoffice — the search term is kept on the view for the title and the search box
		//// (d579b1c02a, 2025-12-14).
		// Store search term for later use (title update, search box prefill)
		this.search_term = search;

		//// Neoffice — second-hand page: a facet the visitor cannot untick,
		//// merged last so the stock and discount defaults above still apply.
		if (window.locked_field_filters) {
			Object.assign(field_filters, window.locked_field_filters);
		}

		const result = {
			field_filters: field_filters,
			attribute_filters: attribute_filters,
			item_group: this.item_group,
			start: filters.start || null,
			//// Neoffice — from_filters and the sort order are sent to the API; upstream sends
			//// neither (the API has no sorting).
			from_filters: this.from_filters || false,
			price_range: price_range || null, // Add the price_range parameter to the query
			sort_order: this.current_sort || 'relevance', // Add sort order
			search: search // Add search parameter to the query
		};
		//// Neoffice — the built filters are returned rather than assigned, so
		//// change_route_with_filters and the live counter can reuse them.
		return result;
	}

	add_paging_section(settings) {
		$(".product-paging-area").remove();
		//// Neoffice — remove the infinite-scroll sentinel before rebuilding the paging.
		$(".infinite-scroll-loader").remove();

		//// Neoffice — the paging section is rebuilt on every filter change, so the
		//// infinite-scroll observer must be disconnected here or it kept loading pages of
		//// the PREVIOUS filter (abea03c4d5, 2025-12-16).
		// Reset infinite scroll state when paging section is rebuilt (e.g., after filter change)
		if (this.infinite_scroll_observer) {
			this.infinite_scroll_observer.disconnect();
			this.infinite_scroll_observer = null;
		}
		this.infinite_scroll_state = null;

		//// Neoffice — the pager reads the results stored on the view; nothing to page
		//// when the query returned before the first render.
		if (!this.products) return;

		// Check if infinite scroll is enabled
		if (settings.enable_infinite_scroll) {
			this.add_infinite_scroll(settings);
			return;
		}

		//// Neoffice — added, down to the end of add_paging_section. ▼▼▼ Upstream ships one
		//// "More" button. Ours is a real pager (first/previous/numbered pages with
		//// ellipsis/next/last) driven by the query string, plus the infinite-scroll mode
		//// when the shop enables it (2591df1013, 2025-12-14). ▲▲▲
		let query_params = frappe.utils.get_query_params();
		let start = query_params.start ? cint(JSON.parse(query_params.start)) : 0;
		let page_length = settings.products_per_page || 0;
		let current_page = Math.floor(start / page_length) + 1;
		let total_count = this.total_count || this.product_count;

		let total_pages = Math.ceil(total_count / page_length);
		
		// Check if discount filter is active
		const saved_discount_preference = webshop.filter_store.get('discount_filter_checked'); //// Neoffice — visit-scoped (webshop.filter_store, 2026-09-14)
		const discount_filter_active = saved_discount_preference === 'true';
		
		// If discount filter is active, handle special cases
		if (discount_filter_active) {
			// If we have no products and we're not on the first page, redirect to first page
			if (this.products.length === 0 && start > 0) {
				const translations = window.product_translations || {};
				frappe.show_alert({
					message: translations["No more discounted products. Returning to first page."] || "No more discounted products. Returning to first page.",
					indicator: 'orange'
				});
				setTimeout(() => {
					window.location.search = this.get_query_string({});
				}, 2000);
				return;
			}
			
			// If we have fewer items than expected, adjust display
			if (this.products.length < page_length && total_pages > current_page) {
				// This might be the last page with discount items
				total_pages = current_page;
			}
		}
		
		//// Neoffice — the pages are links (#691 lot 2): a crawler follows an <a href>, never a
		//// button, and the pager was the only way to the catalogue's other pages. The address is
		//// the one bind_paging_action went to: the URL's own parameters and the page's start.
		const page_href = (page_start) => {
			const query_string = this.get_query_string({...query_params, start: page_start});
			return query_string ? `${window.location.pathname}?${query_string}` : window.location.pathname;
		};

		let paging_html = `
			<div class="row product-paging-area mt-5">
				<div class="col-12 text-center">
					<div class="btn-group">
		`;

		//// Neoffice — previous button (see the block above).
		// Previous button (except for first page)
		if (current_page > 1) {
			//// Neoffice — page buttons carry their data-start (see the block above); a link since #691 lot 2 (page_href)
			paging_html += `<a class="btn btn-default btn-prev" rel="prev" href="${page_href((current_page - 2) * page_length)}" data-start="${(current_page - 2) * page_length}"><svg class="es-icon icon-xs"><use href="#icon-left"></use></svg></a>`;
		//// Neoffice — see the block above.
		}

		//// Neoffice — a window of page numbers, not all of them: a 300-page catalogue
		//// printed 300 buttons.
		// Only show limited page numbers for better UX
		let max_visible_pages = 7;
		let half_visible = Math.floor(max_visible_pages / 2);
		let start_page = Math.max(1, current_page - half_visible);
		let end_page = Math.min(total_pages, start_page + max_visible_pages - 1);
		
		// Adjust start_page if we're near the end
		if (end_page - start_page < max_visible_pages - 1) {
			start_page = Math.max(1, end_page - max_visible_pages + 1);
		}

		// First page and ellipsis if needed
		if (start_page > 1) {
			//// Neoffice — first page + ellipsis (see the block above); a link since #691 lot 2 (page_href)
			paging_html += `<a class="btn btn-default btn-page" href="${page_href(0)}" data-start="0">1</a>`;
			if (start_page > 2) {
				paging_html += `<span class="btn btn-default disabled">...</span>`;
			}
		}

		// Show page numbers
		for (let i = start_page; i <= end_page; i++) {
			let is_current = i === current_page;
			let page_start = (i - 1) * page_length;
			//// Neoffice — the current page is no link (see page_href above)
			paging_html += is_current
				? `<span class="btn btn-default btn-page btn-primary" aria-current="page">${i}</span>`
				: `<a class="btn btn-default btn-page" href="${page_href(page_start)}" data-start="${page_start}">${i}</a>`;
		}

		//// Neoffice — last page + ellipsis (see the block above).
		// Last page and ellipsis if needed
		if (end_page < total_pages) {
			if (end_page < total_pages - 1) {
				paging_html += `<span class="btn btn-default disabled">...</span>`;
			}
			//// Neoffice — the last page, a link since #691 lot 2 (page_href)
			paging_html += `<a class="btn btn-default btn-page" href="${page_href((total_pages - 1) * page_length)}" data-start="${(total_pages - 1) * page_length}">${total_pages}</a>`;
		}

		//// Neoffice — next button (see the block above).
		// Next button (except for last page)
		if (current_page < total_pages) {
			//// Neoffice — a link since #691 lot 2 (page_href)
			paging_html += `<a class="btn btn-default btn-next" rel="next" href="${page_href(current_page * page_length)}" data-start="${current_page * page_length}"><svg class="es-icon icon-xs"><use href="#icon-right"></use></svg></a>`;
		}
//// Neoffice — the pager is only rendered when there is more than one page, and the
//// counter says how many products the filters left (see the block above).

		const translations = window.product_translations || {};
		const pageText = translations["Page"] || "Page";
		const ofText = translations["of"] || "of";
		const productsText = translations["products"] || "products";

		paging_html += `
					</div>
					<div class="mt-3 text-muted">
						${pageText} ${current_page} ${ofText} ${total_pages}
						<i>(${total_count} ${productsText})</i>
					</div>
				</div>
			</div>
		`;

		this.products_section.append(paging_html);
		this.bind_paging_action();
	}

	count_products() {
		let args = this.get_query_filters();
		// Set page_length to 0 to avoid retrieving products
		args.page_length = 0;
		
		return new Promise((resolve) => {
			frappe.call({
				method: "webshop.webshop.api.get_product_filter_data",
				args: {
					query_args: args
				},
				callback: function(result) {
					resolve(result.message.items_count);
				}
			});
		});
	}

	prepare_search() {
		//// Neoffice — the placeholder is translated through window.product_translations;
		//// this bundle has no access to frappe's __() (dd08553e88, 2025-12-15).
		const searchPlaceholder = (window.product_translations && window.product_translations["Search for Products"]) || "Search for Products";
		
		//// Neoffice — the search box takes the free space and stacks on mobile.
		$(".toolbar").append(`
			<div class="input-group flex-grow-1 mb-2 mb-md-0 mr-md-3">
				<div class="dropdown w-100" id="dropdownMenuSearch">
					<input type="search" name="query" id="search-box" class="form-control font-md"
						placeholder="${searchPlaceholder}"
						aria-label="Product" aria-describedby="button-addon2">
					<div class="search-icon">
						<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24"
							fill="none"
							stroke="currentColor" stroke-width="2" stroke-linecap="round"
							stroke-linejoin="round"
							class="feather feather-search">
							<circle cx="11" cy="11" r="8"></circle>
							<line x1="21" y1="21" x2="16.65" y2="16.65"></line>
						</svg>
					</div>
					<!-- Results dropdown rendered in product_search.js -->
				</div>
			</div>
		`);
		//// Neoffice — a quiet way in to the quick order, next to the search box (2026-09-14):
		//// a customer who knows the references types them there and a grid per model opens.
		//// Offered only to whoever may use it (listing_context.quick_order_url).
		if (window.quick_order_url) {
			const t = window.product_translations || {};
			const esc = (s) => String(s).replace(/[&<>"']/g, (c) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c]));
			const label = t["Quick order"] || "Quick order";
			const hint = t["Know your references? Order them by code, name or barcode."] || "Know your references? Order them by code, name or barcode.";
			$(".toolbar").append(`
				<a class="wsp-quick-order-link mb-2 mb-md-0 mr-md-3" href="${esc(window.quick_order_url)}" title="${esc(hint)}">
					<svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"></polygon></svg>
					<span>${esc(label)}</span>
				</a>
			`);
		}
	}

	render_view_toggler() {
		//// Neoffice — the view toggles keep their own container so the toolbar can wrap.
		$(".toolbar").append(`<div class="toggle-container d-flex justify-content-between align-items-center flex-grow-0"></div>`);

		["btn-list-view", "btn-grid-view"].forEach(view => {
			let icon = view === "btn-list-view" ? "list" : "image-view";
			//// Neoffice — `image-view` → `grid` (see prepare_view_toggler).
			let view_id = view === "btn-list-view" ? "list" : "grid";
			//// Neoffice — the button carries the view id used everywhere else.
			$(".toggle-container").append(`
				<div class="form-group mb-0" id="toggle-view">
					<button id="${ view_id }" class="btn ${ view } mr-2">
						<span>
							<svg class="icon icon-md">
								<use href="#icon-${ icon }"></use>
							</svg>
						</span>
					</button>
				</div>
			`);
		});
	}

	bind_view_toggler_actions() {
		$("#list").click(function() {
			let $btn = $(this);
			$btn.removeClass('btn-primary');
			$btn.addClass('btn-primary');
			$(".btn-grid-view").removeClass('btn-primary');

			$("#products-grid-area").addClass("hidden");
			$("#products-list-area").removeClass("hidden");
			localStorage.setItem("product_view", "List View");
		});

		//// Neoffice — `#image-view` → `#grid`.
		$("#grid").click(function() {
			let $btn = $(this);
			$btn.removeClass('btn-primary');
			$btn.addClass('btn-primary');
			$(".btn-list-view").removeClass('btn-primary');

			$("#products-list-area").addClass("hidden");
			$("#products-grid-area").removeClass("hidden");
			localStorage.setItem("product_view", "Grid View");
		});
	}

	set_view_state() {
		if (this.preference === "List View") {
			$("#list").addClass('btn-primary');
			//// Neoffice — `#image-view` → `#grid`.
			$("#grid").removeClass('btn-primary');
		} else {
			//// Neoffice — `#image-view` → `#grid`.
			$("#grid").addClass('btn-primary');
			$("#list").removeClass('btn-primary');
		}
	}

	bind_paging_action() {
		let me = this;
		//// Neoffice — upstream binds only its "More" button; ours binds the three kinds of
		//// pager button (2591df1013, 2025-12-14).
		$('.btn-prev, .btn-next, .btn-page').on('click', function(e) {
			const $btn = $(this);
			const start = $btn.data('start');
			//// Neoffice — the pages are links now (#691 lot 2); the current one carries no start
			if (start === undefined) return;
			e.preventDefault();

			let query_params = frappe.utils.get_query_params();
			query_params.start = start;
			//// Neoffice — the whole query string is rewritten, so a page change keeps the
			//// filters that are in the URL.
			window.location.search = me.get_query_string(query_params);
		});
	}

	//// Neoffice — added, down to update_infinite_scroll_status. ▼▼▼ Infinite scroll
	//// (Webshop Settings.enable_infinite_scroll): an IntersectionObserver on a
	//// sentinel loads the next page and APPENDS it, where upstream replaces the list.
	//// from_filters is deliberately NOT sent on pages 2+ — sending it reset the
	//// server-side filter state and page 2 came back as page 1 (aa3d5621b2,
	//// 2025-12-16). ▲▲▲
	add_infinite_scroll(settings) {
		let me = this;
		let page_length = settings.products_per_page || 12;
		let total_count = this.total_count || this.product_count;
		let current_loaded = this.products ? this.products.length : 0;

		// Initialize infinite scroll state
		if (!this.infinite_scroll_state) {
			this.infinite_scroll_state = {
				start: 0,
				loading: false,
				all_loaded: false
			};
		}

		//// Neoffice — the next batch starts after the page the visitor landed on (#691 lot 2):
		//// with the pages linked, a visit can begin at ?start=24, and the next batch asked for 12,
		//// offering the products already on screen again.
		const landed_on = cint((frappe.utils.get_query_params() || {}).start || 0);
		// Update start position based on currently loaded products
		this.infinite_scroll_state.start = landed_on + current_loaded;

		// Check if all products are loaded
		//// Neoffice — counted from the page the visit landed on (see landed_on above)
		if (landed_on + current_loaded >= total_count) {
			this.infinite_scroll_state.all_loaded = true;
		}

		// Add loader element at the bottom
		const translations = window.product_translations || {};
		const loadingText = translations["Loading more products..."] || "Loading more products...";
		const allLoadedText = translations["All products loaded"] || "All products loaded";
		const productsText = translations["products"] || "products";

		let loader_html = `
			<div class="infinite-scroll-loader text-center py-4">
				${this.infinite_scroll_state.all_loaded ?
					`<div class="text-muted">${allLoadedText} (${total_count} ${productsText})</div>` :
					`<div class="infinite-scroll-spinner" style="display: none;">
						<div class="spinner-border text-primary" role="status">
							<span class="sr-only">${loadingText}</span>
						</div>
						<div class="mt-2 text-muted">${loadingText}</div>
					</div>
					<div class="infinite-scroll-sentinel" style="height: 1px;"></div>`
				}
			</div>
		`;

		this.products_section.append(loader_html);

		// Set up IntersectionObserver for infinite scroll
		if (!this.infinite_scroll_state.all_loaded && !this.infinite_scroll_observer) {
			this.setup_infinite_scroll_observer(settings);
		}
	}

	setup_infinite_scroll_observer(settings) {
		let me = this;

		// Clean up existing observer
		if (this.infinite_scroll_observer) {
			this.infinite_scroll_observer.disconnect();
		}

		const sentinel = document.querySelector('.infinite-scroll-sentinel');
		if (!sentinel) return;

		const options = {
			root: null,
			rootMargin: '200px', // Load before reaching the bottom
			threshold: 0
		};

		this.infinite_scroll_observer = new IntersectionObserver((entries) => {
			entries.forEach(entry => {
				if (entry.isIntersecting && !me.infinite_scroll_state.loading && !me.infinite_scroll_state.all_loaded) {
					me.load_next_page(settings);
				}
			});
		}, options);

		this.infinite_scroll_observer.observe(sentinel);
	}

	load_next_page(settings) {
		let me = this;

		if (this.infinite_scroll_state.loading || this.infinite_scroll_state.all_loaded) {
			return;
		}

		this.infinite_scroll_state.loading = true;

		// Show spinner
		$('.infinite-scroll-spinner').show();

		let args = this.get_query_filters();
		args.start = this.infinite_scroll_state.start;
		// IMPORTANT: Don't send from_filters=true for pagination - it resets start to 0 in backend
		args.from_filters = false;

		frappe.call({
			method: "webshop.webshop.api.get_product_filter_data",
			args: {
				query_args: args
			},
			callback: function(result) {
				//// Neoffice — a filter change resets the state while a page may still be in
				//// flight: its callback then wrote on null ("Cannot set properties of null",
				//// 2026-09-13). A stale answer is dropped.
				if (!me.infinite_scroll_state) return;
				me.infinite_scroll_state.loading = false;
				$('.infinite-scroll-spinner').hide();

				if (!result || result.exc || !result.message || result.message.exc) {
					return;
				}

				const new_items = result.message["items"] || [];

				if (new_items.length === 0) {
					me.infinite_scroll_state.all_loaded = true;
					me.update_infinite_scroll_status();
					return;
				}

				// Append new products to existing ones
				me.products = me.products.concat(new_items);
				me.infinite_scroll_state.start += new_items.length;

				// Check if all products are loaded
				const total_count = me.total_count || result.message["total_count"];
				if (me.infinite_scroll_state.start >= total_count) {
					me.infinite_scroll_state.all_loaded = true;
				}

				// Append new items to the view
				me.append_products(new_items, settings);

				// Update status
				me.update_infinite_scroll_status();
			},
			error: function() {
				//// Neoffice — the state may have been reset by a filter change meanwhile
				if (me.infinite_scroll_state) me.infinite_scroll_state.loading = false;
				$('.infinite-scroll-spinner').hide();
			}
		});
	}

	append_products(items, settings) {
		// Append to grid view
		if (this.preference === "Grid View") {
			const $grid = $("#products-grid-area");
			items.forEach(item => {
				const html = this.get_grid_item_html(item, settings);
				$grid.append(html);
			});
		} else {
			// Append to list view
			const $list = $("#products-list-area");
			items.forEach(item => {
				const html = this.get_list_item_html(item, settings);
				$list.append(html);
			});
		}
	}

	get_grid_item_html(item, settings) {
		// Reuse ProductGrid logic for consistency
		const grid = new webshop.ProductGrid({
			items: [item],
			products_section: $('<div>'),
			settings: settings,
			preference: this.preference,
			no_render: true
		});
		return grid.get_item_html(item);
	}

	get_list_item_html(item, settings) {
		// Reuse ProductList logic for consistency
		const list = new webshop.ProductList({
			items: [item],
			products_section: $('<div>'),
			settings: settings,
			preference: this.preference,
			no_render: true
		});
		return list.get_item_html(item);
	}

	update_infinite_scroll_status() {
		const translations = window.product_translations || {};
		const allLoadedText = translations["All products loaded"] || "All products loaded";
		const productsText = translations["products"] || "products";
		const total_count = this.total_count || this.product_count;

		if (this.infinite_scroll_state.all_loaded) {
			$('.infinite-scroll-loader').html(
				`<div class="text-muted py-3">${allLoadedText} (${total_count} ${productsText})</div>`
			);

			// Disconnect observer
			if (this.infinite_scroll_observer) {
				this.infinite_scroll_observer.disconnect();
				this.infinite_scroll_observer = null;
			}
		}
	}

	re_render_discount_filters() {
		this.get_discount_filter_html();
		if (this.from_filters) {
			// Bind filter action if triggered via filters
			// if not from filter action, page load will bind actions
			this.bind_discount_filter_action();
		}
		// discount filters are rendered with Items (later)
		// unlike the other filters
		this.restore_discount_filter();
	}

	//// Neoffice — the discount filter block is built here rather than served by the
	//// API, so it can be re-rendered without a round-trip (8ba1a7ab46, 2025-06-08).
	get_discount_filter_html() {
		$("#discount-filters").remove();
		//// Neoffice — no discounted product, no toggle (2026-09-14): a filter that leads to an
		//// empty grid is a promise with nothing behind it; the second-hand toggle already hides
		//// the same way. window.discount_count is the cached figure of listing_context.
		if (window.discount_count === 0) {
			this.get_second_hand_filter_html();
			return;
		}
		//// Neoffice — translated through window.product_translations (dd08553e88).
		const translations = window.product_translations || {};

		//// Neoffice — the discount checkbox is inserted next to the stock filter in the
		//// sidebar; upstream has neither.
		// Find the stock filter section
		const $stockFilter = $('#product-filters').find('.filter-block').filter(function() {
			return $(this).find('.filter-label').text().includes('Availability');
		});

		//// Neoffice — the discount block is always rendered (upstream renders a facet only
		//// when the API returns values for it), so the box keeps its place when the
		//// current result set happens to hold no discounted product.
		// Always show the discount filter section before stock filter
		const discountSection = `
			<div id="discount-filters" class="mb-4 filter-block pb-5">
				<div class="filter-label mb-3">${ translations["Discounts"] || "Discounts" }</div>
			</div>
		`;

		//// Neoffice — see above (placement next to the stock filter).
		if ($stockFilter.length) {
			$stockFilter.before(discountSection);
		} else {
			// If no stock filter, append to the end
			$("#product-filters").append(discountSection);
		}
//// Neoffice — see above.

		let html = `<div class="filter-options">`;

		// Only add "Show only products with discount" checkbox
		html += `
			<div class="checkbox">
				<label>
					<input type="checkbox"
						class="product-filter discount-filter"
						id="showDiscountOnly"
						name="discount"
						data-filter-name="discount"
						data-filter-value="100"
						style="width: 14px !important"
					>
						<!-- //// Neoffice — the figure next to the toggle, like the second-hand one (2026-09-14) -->
						<span class="label-area" for="showDiscountOnly">
							${ translations["Show only products with discount"] || "Show only products with discount" }${ window.discount_count ? " (" + window.discount_count + ")" : "" }
						</span>
					</label>
				</div>
		`;

		html += `</div>`;

		$("#discount-filters").append(html);
		this.get_second_hand_filter_html();
	}

	//// Neoffice — the second-hand toggle (2026-09-13): the catalogue used to point at
	//// /occasions through a link at the top of the sidebar; the shop asked for a filter
	//// next to the discount one, working the same way — a checkbox, a per-visitor
	//// preference, a chip. Drawn only when the shop has a used unit published, and not
	//// on the second-hand page itself, where the condition is locked.
	get_second_hand_filter_html() {
		$("#second-hand-filters").remove();
		if (!window.second_hand_count) return;
		if (window.locked_field_filters && window.locked_field_filters.item_condition) return;
		const translations = window.product_translations || {};
		const section = `
			<div id="second-hand-filters" class="mb-4 filter-block pb-5">
				<div class="filter-label mb-3">${ translations["Second-hand"] || "Second-hand" }</div>
				<div class="filter-options">
					<div class="checkbox">
						<label>
							<input type="checkbox"
								class="product-filter second-hand-filter"
								id="showSecondHandOnly"
								name="second_hand"
								data-filter-name="second_hand"
								data-filter-value="1"
								style="width: 14px !important"
							>
							<span class="label-area" for="showSecondHandOnly">
								${ translations["Show only second-hand items"] || "Show only second-hand items" } (${ window.second_hand_count })
							</span>
						</label>
					</div>
				</div>
			</div>
		`;
		if ($("#discount-filters").length) {
			$("#discount-filters").after(section);
		} else {
			$("#product-filters").append(section);
		}
		//// Neoffice — the Condition facet (New / Second-hand / Refurbished) says the same
		//// thing twice once the toggle is there: it steps aside in the sidebar
		$('input[data-filter-name="item_condition"]').closest('.filter-block').remove();
	}

	restore_discount_filter() {
		const filters = frappe.utils.get_query_params();
		let field_filters = filters.field_filters;
		//// Neoffice — restore_discount_filter: the state lives in localStorage, so it has
		//// to be re-applied after every render.
		
		// First check URL parameters
		if (field_filters) {
			// Safe parsing with proper decoding
			try {
				field_filters = JSON.parse(decodeURIComponent(field_filters));
			} catch (e) {
				// Try without decoding as fallback
				try {
					field_filters = JSON.parse(field_filters);
				} catch (e2) {
					console.error("Error parsing discount filters:", e2);
					field_filters = null;
				}
			}

			//// Neoffice — the discount filter is also mirrored into field_filters when it comes
			//// from the URL (?discount=true from a carousel).
			if (field_filters && field_filters["discount"]) {
				const values = field_filters["discount"];
				const selector = values.map(value => {
					return `input[data-filter-name="discount"][data-filter-value="${value}"]`;
				}).join(',');
				$(selector).prop('checked', true);
				this.field_filters = field_filters;
			}
		}
		
		// Also check localStorage for the discount filter state
		const saved_discount_preference = webshop.filter_store.get('discount_filter_checked'); //// Neoffice — visit-scoped (webshop.filter_store, 2026-09-14)
		if (saved_discount_preference === 'true') {
			$('#showDiscountOnly').prop('checked', true);
			// If checkbox is checked via localStorage, also update field_filters
			if (!this.field_filters) {
				this.field_filters = {};
			}
			this.field_filters["discount"] = ["100"];
		}
		//// Neoffice — and the second-hand toggle (see get_second_hand_filter_html)
		if (webshop.filter_store.get('second_hand_filter_checked') === 'true') { //// Neoffice — visit-scoped (webshop.filter_store, 2026-09-14)
			$('#showSecondHandOnly').prop('checked', true);
			this.field_filters = this.field_filters || {};
			this.field_filters["second_hand"] = ["1"];
		}
	}

	bind_discount_filter_action() {
		let me = this;
		//// Neoffice — see above.
		
		// Preload discount results if discount filter was previously enabled
		if (webshop.filter_store.get('discount_filter_checked') === 'true' && !this.preload_in_progress) { //// Neoffice — visit-scoped (webshop.filter_store, 2026-09-14)
			this.preloadDiscountResults();
		}
		
		//// Neoffice — the second-hand toggle: same life as the discount one (2026-09-13)
		$('.second-hand-filter').off('change.wspSecondHand').on('change.wspSecondHand', (e) => {
			const is_checked = $(e.target).is(':checked');
			webshop.filter_store.set('second_hand_filter_checked', is_checked ? 'true' : 'false'); //// Neoffice — visit-scoped (webshop.filter_store, 2026-09-14)
			if (is_checked && webshop.filter_store.get('stock_filter_checked') === null) { //// Neoffice — visit-scoped (webshop.filter_store, 2026-09-14)
				webshop.filter_store.set('stock_filter_checked', 'false'); //// Neoffice — visit-scoped (webshop.filter_store, 2026-09-14)
			}
			this.field_filters = this.field_filters || {};
			if (is_checked) {
				this.field_filters["second_hand"] = ["1"];
			} else {
				delete this.field_filters["second_hand"];
			}
			me.from_filters = true;
			me.change_route_with_filters();
		});

		$('.discount-filter').on('change', (e) => {
			const $checkbox = $(e.target);
			const is_checked = $checkbox.is(':checked');
			//// Neoffice — bind_discount_filter_action: checking the box re-queries and stores
			//// the preference; upstream has no such filter.
			
			// Get the filter value from the data-filter-value attribute
			const filter_value = $checkbox.attr('data-filter-value');
			
			// Special handling for "Show only products with discount" checkbox
			if ($checkbox.attr('id') === 'showDiscountOnly') {
				// Save preference in localStorage like stock filter
				webshop.filter_store.set('discount_filter_checked', is_checked ? 'true' : 'false'); //// Neoffice — visit-scoped (webshop.filter_store, 2026-09-14)
				
				// If enabling discount filter and stock filter has no saved preference, save it as false
				// This prevents the default stock filter from being applied on mobile
				if (is_checked && webshop.filter_store.get('stock_filter_checked') === null) { //// Neoffice — visit-scoped (webshop.filter_store, 2026-09-14)
					webshop.filter_store.set('stock_filter_checked', 'false'); //// Neoffice — visit-scoped (webshop.filter_store, 2026-09-14)
				}
				
				// Force immediate update of filters
				if (is_checked) {
					this.field_filters = this.field_filters || {};
					this.field_filters["discount"] = ["100"];
					
					// Start preloading for next time if not already done
					if (!this.preload_in_progress) {
						this.preloadDiscountResults();
					}
				} else {
					if (this.field_filters) {
						delete this.field_filters["discount"];
					}
					// Clear preloaded results when discount filter is disabled
					this.preloaded_discount_results = null;
				}
				
				// Set from_filters to true to ensure filters are applied
				me.from_filters = true;
				me.change_route_with_filters();
				return;
			}
			
			// For percentage discount filters
			delete this.field_filters["discount"];

			if (is_checked) {
				this.field_filters["discount"] = [];
				this.field_filters["discount"].push(filter_value);
			}

			//// Neoffice — an empty discount filter is removed from field_filters, or the query
			//// carried `discount: []` and returned nothing.
			if (!this.field_filters["discount"] || this.field_filters["discount"].length === 0) {
				delete this.field_filters["discount"];
			}

			me.change_route_with_filters();
		});
	}
	//// Neoffice — preloadDiscountResults: the discounted list is fetched in the
	//// background so ticking the box is instant (84d621a387, 2025-06-23 "new
	//// optimized method with caching").
	
	preloadDiscountResults() {
		// Avoid duplicate preloading
		if (this.preload_in_progress) return;
		
		this.preload_in_progress = true;
		
		// Get current webshop settings
		const settings = window.product_settings || {};
		const price_list = settings.price_list || null;
		
		// Preload discount items in background
		frappe.call({
			method: "webshop.webshop.api.get_discount_items_preview",
			args: {
				limit: 20,
				price_list: price_list
			},
			callback: (r) => {
				if (r.message) {
					this.preloaded_discount_results = r.message;
				}
				this.preload_in_progress = false;
			},
			error: () => {
				this.preload_in_progress = false;
			}
		});
	}

	bind_filters() {
		let me = this;
		//// Neoffice — "Clear all" clears the visit's toggles too (2026-09-14): it only loaded the
		//// listing's bare route, and a stored toggle came straight back.
		$(document).off('click.wspClearAll').on('click.wspClearAll', '.clear-filters', () => webshop.filter_store.clear());
		this.field_filters = {};
		this.attribute_filters = {};
		//// Neoffice — tag filters (Webshop Settings.enable_tag_filters), which upstream
		//// does not have (6fea19b1fe, 2025-06-17).
		this.tag_filters = [];
		this.price_range = {};
		
		// Initialize stock filter based on saved preference or default
		const url_filters = frappe.utils.get_query_params().field_filters;
		if (!url_filters) {
			// No filters in URL, check saved preferences
			
			// Stock filter
			const saved_stock_preference = webshop.filter_store.get('stock_filter_checked'); //// Neoffice — visit-scoped (webshop.filter_store, 2026-09-14)
			let should_apply_stock = false;
			
			if (saved_stock_preference !== null) {
				should_apply_stock = saved_stock_preference === 'true';
			} else {
				should_apply_stock = this.stock_filter_default;
			}
			
			if (should_apply_stock) {
				this.field_filters["in_stock"] = ["1"];
			}
			
			// Discount filter
			const saved_discount_preference = webshop.filter_store.get('discount_filter_checked'); //// Neoffice — visit-scoped (webshop.filter_store, 2026-09-14)
			if (saved_discount_preference === 'true') {
				this.field_filters["discount"] = ["100"];
			}
		}

		$('.product-filter').on('change', (e) => {
			me.from_filters = true;

			const $checkbox = $(e.target);
			const is_checked = $checkbox.is(':checked');
			//// Neoffice — see above (tag filters bound like the field filters).
			
			// Reset price filter if another filter is modified
			if (!$checkbox.is('.price-filter')) {
				$('.price-filter').prop('checked', false);
				$('#price-min').val('');
				$('#price-max').val('');
				this.price_range = {};
			}
			
			// Special handling for discount filter - skip here as it's handled separately
			if ($checkbox.is('.discount-filter')) {
				return;
			}
			
			// Special handling for stock filter
			if ($checkbox.is('.stock-filter')) {
				if (is_checked) {
					this.field_filters["in_stock"] = ["1"];
					// Save user preference
					webshop.filter_store.set('stock_filter_checked', 'true'); //// Neoffice — visit-scoped (webshop.filter_store, 2026-09-14)
				} else {
					// When unchecked, remove the filter completely
					delete this.field_filters["in_stock"];
					// Save user preference
					webshop.filter_store.set('stock_filter_checked', 'false'); //// Neoffice — visit-scoped (webshop.filter_store, 2026-09-14)
				}
				me.change_route_with_filters();
				return;
			}

			if ($checkbox.is('.attribute-filter')) {
				const {
					attributeName: attribute_name,
					attributeValue: attribute_value
				} = $checkbox.data();

				if (is_checked) {
					this.attribute_filters[attribute_name] = this.attribute_filters[attribute_name] || [];
					this.attribute_filters[attribute_name].push(attribute_value);
				} else {
					this.attribute_filters[attribute_name] = this.attribute_filters[attribute_name] || [];
					this.attribute_filters[attribute_name] = this.attribute_filters[attribute_name].filter(v => v !== attribute_value);
				}

				if (this.attribute_filters[attribute_name].length === 0) {
					delete this.attribute_filters[attribute_name];
				}
			//// Neoffice — the three filter classes we add are recognised here alongside
			//// upstream's field filters.
			} else if ($checkbox.is('.field-filter') || $checkbox.is('.discount-filter') || $checkbox.is('.tag-filter')) {
				const {
					filterName: filter_name,
					filterValue: filter_value
				} = $checkbox.data();

				if ($checkbox.is('.discount-filter')) {
					// clear previous discount filter to accomodate new
					delete this.field_filters["discount"];
				}
				//// Neoffice — a filter change resets the paging and the infinite scroll before
				//// re-querying (abea03c4d5, 2025-12-16).
				
				// Handle special handling for tag filters
				if ($checkbox.is('.tag-filter')) {
					if (is_checked) {
						// Add tag to filter
						if (!this.field_filters["_user_tags"]) {
							this.field_filters["_user_tags"] = [];
						}
						if (!in_list(this.field_filters["_user_tags"], filter_value)) {
							this.field_filters["_user_tags"].push(filter_value);
						}
					} else {
						// Remove tag from filter
						if (this.field_filters["_user_tags"]) {
							this.field_filters["_user_tags"] = this.field_filters["_user_tags"].filter(v => v !== filter_value);
							if (this.field_filters["_user_tags"].length === 0) {
								delete this.field_filters["_user_tags"];
							}
						}
					}
				}
				if (is_checked) {
					this.field_filters[filter_name] = this.field_filters[filter_name] || [];
					if (!in_list(this.field_filters[filter_name], filter_value)) {
						this.field_filters[filter_name].push(filter_value);
					}
				} else {
					this.field_filters[filter_name] = this.field_filters[filter_name] || [];
					this.field_filters[filter_name] = this.field_filters[filter_name].filter(v => v !== filter_value);
				}

				if (this.field_filters[filter_name].length === 0) {
					delete this.field_filters[filter_name];
				}
			}

			me.change_route_with_filters();
		});

		// bind filter lookup input box
		$('.filter-lookup-input').on('keydown', frappe.utils.debounce((e) => {
			const $input = $(e.target);
			const keyword = ($input.val() || '').toLowerCase();
			const $filter_options = $input.next('.filter-options');

			//// Neoffice — added: the keyword box filters the facet values themselves (a shop
			//// with 200 brands was unusable), and the price filter is wired here.
			if (!keyword) {
				// If search is cleared, show all and collapse hierarchical groups
				$filter_options.find('.filter-lookup-wrapper').show();
				$filter_options.find('.children-container').hide();
				$filter_options.find('.toggle-children').text('+').attr('data-expanded', 'false');
			} else {
				// First, hide all items
				$filter_options.find('.filter-lookup-wrapper').hide();
				
				// Then show items that match the search
				$filter_options.find('.filter-lookup-wrapper').each((i, el) => {
					const $el = $(el);
					const value = ($el.data('value') || '').toLowerCase();
					
					if (value.includes(keyword)) {
						// Show this element
						$el.show();
						
						// If it's a hierarchical item group, show all parents
						$el.parents('.filter-lookup-wrapper').show();
						
						// If it has children, expand and show all children
						const $childContainer = $el.find('> .children-container');
						if ($childContainer.length > 0) {
							$childContainer.show();
							$childContainer.find('.filter-lookup-wrapper').show();
							$el.find('> .d-flex .toggle-children').text('-').attr('data-expanded', 'true');
						}
						
						// Also expand parent containers that contain this item
						$el.parents('.children-container').each(function() {
							$(this).show();
							$(this).prev('.d-flex').find('.toggle-children').text('-').attr('data-expanded', 'true');
						});
					}
				});
			}
		}, 300));
		
		// Initialize price filters
		this.bind_price_filters();
		
		// Bind discount filter actions
		this.bind_discount_filter_action();
	}
	
	update_price_filter_range(price_filters) {
		// Update the price filter range based on current filters
		if (price_filters && price_filters.length > 0) {
			const price_range = price_filters[0]; // First element contains min/max values
			if (price_range.min_value !== undefined && price_range.max_value !== undefined) {
				// Update the hidden values
				$('#price-range-min-value').text(price_range.min_value);
				$('#price-range-max-value').text(price_range.max_value);
				
				// Update the input placeholders
				$('#price-min').attr('placeholder', price_range.min_value);
				$('#price-max').attr('placeholder', price_range.max_value);
				$('#price-max').attr('max', price_range.max_value);
				
				// Re-initialize the price slider if it exists
				if (this.price_slider_initialized) {
					this.bind_price_filters();
				}
			//// Neoffice — update_price_filter_range: the slider bounds follow the current
			//// result set, so they stay meaningful after a filter (6fea19b1fe, 2025-06-17).
			}
		}
	}
	
	bind_price_filters() {
		let me = this;
		
		// Get the minimum and maximum price values from the DOM
		const min_price_value = parseInt($('#price-range-min-value').text()) || 0;
		const max_price_value = parseInt($('#price-range-max-value').text()) || 10000;
		
		// Variables to store the current state of the slider
		let current_min = min_price_value;
		let current_max = max_price_value;
		
		// Get DOM elements
		const $track = $('#price-slider-track');
		const $min_handle = $('#price-slider-min');
		const $max_handle = $('#price-slider-max');
		const $selection = $('#price-slider-selection');
		const $min_input = $('#price-min');
		const $max_input = $('#price-max');

		//// Neoffice — bound once: this method runs again after every filter change (the
		//// bounds follow the result set), and each run stacked a new set of handlers on the
		//// same handles and inputs, each with its own stale bounds — after a few filters a
		//// drag fought itself and the inputs were rewritten by old closures (2026-09-13).
		$min_handle.add($max_handle).off('.wspPrice');
		$min_input.add($max_input).off('.wspPrice');
		
		// Function to convert a price value to a position on the slider (in percentage)
		const priceToPosition = (price) => {
			return ((price - min_price_value) / (max_price_value - min_price_value)) * 100;
		};
		
		// Function to convert a position on the slider to a price value
		const positionToPrice = (position) => {
			const percentage = Math.max(0, Math.min(100, position)) / 100;
			return Math.round(min_price_value + percentage * (max_price_value - min_price_value));
		};
		
		// Function to update the slider display
		const updateSlider = () => {
			const min_pos = priceToPosition(current_min);
			const max_pos = priceToPosition(current_max);
			
			$min_handle.css('left', `${min_pos}%`);
			$max_handle.css('left', `${max_pos}%`);
			$selection.css({
				'left': `${min_pos}%`,
				'width': `${max_pos - min_pos}%`
			});
			//// Neoffice — added, down to refresh_list_view. ▼▼▼ bind_price_filters: the
			//// two-handle price slider and its two number inputs, debounced, writing a
			//// price_range filter into the URL. Upstream filters on attributes and item groups
			//// only (6fea19b1fe, 2025-06-17). ▲▲▲
			
			$min_input.val(current_min);
			$max_input.val(current_max);
		};
		
		// Initialize the slider
		updateSlider();
		
		// Handle the drag of the slider handles
		let isDragging = false;
		let currentHandle = null;
		
		//// Neoffice — bound under the .wspPrice namespace, unbound before each rebind (see above)
		$min_handle.add($max_handle).on('mousedown.wspPrice touchstart.wspPrice', function(e) {
			e.preventDefault();
			isDragging = true;
			currentHandle = $(this).is($min_handle) ? 'min' : 'max';
			$(document).on('mousemove touchmove', handleDrag);
			$(document).on('mouseup touchend', stopDrag);
		});
		
		const handleDrag = (e) => {
			if (!isDragging) return;
			
			const trackWidth = $track.width();
			const trackOffset = $track.offset().left;
			let pageX = e.pageX;
			
			// Support for touch events
			if (e.touches && e.touches.length) {
				pageX = e.touches[0].pageX;
			}
			
			const position = ((pageX - trackOffset) / trackWidth) * 100;
			const price = positionToPrice(position);
			
			if (currentHandle === 'min') {
				current_min = Math.min(price, current_max - 1);
			} else {
				current_max = Math.max(price, current_min + 1);
			}
			
			updateSlider();
		};
		
		const stopDrag = () => {
			isDragging = false;
			$(document).off('mousemove touchmove', handleDrag);
			$(document).off('mouseup touchend', stopDrag);
			
			// Apply filters automatically when the user releases the handle
			applyPriceFilter();
		};
		
		// Handle changes in input fields
		//// Neoffice — bound under the .wspPrice namespace, unbound before each rebind (see above)
		$min_input.on('input.wspPrice', function() {
			// Ensure the value is between 0 and current_max - 1
			let value = parseInt($(this).val()) || min_price_value;
			value = Math.max(0, Math.min(value, current_max - 1));
			current_min = value;
			updateSlider();
		});
		
		//// Neoffice — bound under the .wspPrice namespace, unbound before each rebind (see above)
		$min_input.on('change.wspPrice', function() {
			// Ensure the value is between 0 and current_max - 1
			let value = parseInt($(this).val()) || min_price_value;
			value = Math.max(0, Math.min(value, current_max - 1));
			current_min = value;
			$(this).val(value); // Update the field with the corrected value
			updateSlider();
			// Apply filters automatically when the user finishes typing
			applyPriceFilter();
		});
		
		//// Neoffice — bound under the .wspPrice namespace, unbound before each rebind (see above)
		$max_input.on('input.wspPrice', function() {
			// Ensure the value is between current_min + 1 and max_price_value
			let value = parseInt($(this).val()) || max_price_value;
			value = Math.min(max_price_value, Math.max(value, current_min + 1));
			current_max = value;
			updateSlider();
		});
		
		//// Neoffice — bound under the .wspPrice namespace, unbound before each rebind (see above)
		$max_input.on('change.wspPrice', function() {
			// Ensure the value is between current_min + 1 and max_price_value
			let value = parseInt($(this).val()) || max_price_value;
			value = Math.min(max_price_value, Math.max(value, current_min + 1));
			current_max = value;
			$(this).val(value); // Update the field with the corrected value
			updateSlider();
			// Apply filters automatically when the user finishes typing
			applyPriceFilter();
		});
		
		// Function to apply filters automatically
		const applyPriceFilter = () => {
			// Check if the values have changed compared to the previous values
			const previousPriceRange = {...me.price_range};
			
			// Reset the price_range object before updating
			me.price_range = {};
			
			// Do not include min/max values if they are equal to the extremes
			if (current_min > min_price_value) {
				me.price_range.min = current_min;
			}
			
			if (current_max < max_price_value) {
				me.price_range.max = current_max;
			}
			
			// Always apply the filter, even if we return to default values
			// This allows to correctly reset the filters
			const hasChanges = (
				previousPriceRange.min !== me.price_range.min || 
				previousPriceRange.max !== me.price_range.max ||
				(Object.keys(previousPriceRange).length > 0 && Object.keys(me.price_range).length === 0) ||
				(Object.keys(previousPriceRange).length === 0 && Object.keys(me.price_range).length > 0)
			);
			
			// If the values have changed or if we have returned to default values, apply the filter
			if (hasChanges) {
				me.change_route_with_filters();
			}
		};
		
		// Restore price filters from URL if necessary
		const restore_price_filters = () => {
			const url_params = new URLSearchParams(window.location.search);
			const price_range_param = url_params.get('price_range');
			
			if (price_range_param) {
				try {
					const price_range = JSON.parse(decodeURIComponent(price_range_param));
					
					//// Neoffice — clamped to the current bounds: after a filter the range of the
					//// result set may no longer contain what the URL remembers (2026-09-13).
					if (price_range.min !== undefined) {
						current_min = Math.max(min_price_value, Math.min(parseInt(price_range.min), max_price_value - 1));
					}
					
					if (price_range.max !== undefined) {
						//// Neoffice — clamped to the current bounds (see above)
						current_max = Math.min(max_price_value, Math.max(parseInt(price_range.max), current_min + 1));
					}
					
					updateSlider();
				} catch (e) {
					console.error('Erreur lors de la restauration des filtres de prix:', e);
				}
			}
		};
		
		// Call the restore function
		restore_price_filters();
		
		// Mark that price slider is initialized
		me.price_slider_initialized = true;
	}

	refresh_list_view() {
		// This method is called when price filters are modified
		// Use change_route_with_filters directly to avoid parameter duplication
		this.change_route_with_filters();
	}

	change_route_with_filters() {
		let route_params = frappe.utils.get_query_params();

		let start = this.if_key_exists(route_params.start) || 0;
		if (this.from_filters) {
			start = 0; // show items from first page if new filters are triggered
		}

		//// Neoffice — the stock and discount filters are NOT written into the URL: they are
		//// a per-visitor preference kept in localStorage, and putting them in the route
		//// made every shared link carry someone else's preferences.
		// Create a copy of field_filters excluding localStorage-managed filters
		let url_field_filters = {};
		if (this.field_filters) {
			for (let key in this.field_filters) {
				// Exclude stock and discount filters from URL (they use localStorage)
				if (key !== 'in_stock' && key !== 'discount') {
					url_field_filters[key] = this.field_filters[key];
				}
			}
		}

		// Check if we have any filters to put in URL
		const has_url_field_filters = this.if_key_exists(url_field_filters);
		const has_attribute_filters = this.if_key_exists(this.attribute_filters);
		const has_price_filters = this.price_range && (this.price_range.min || this.price_range.max);
		
		// If no filters and start is 0, use clean URL
		if (!has_url_field_filters && !has_attribute_filters && !has_price_filters && start === 0) {
			window.history.pushState('filters', '', location.pathname);
		} else {
			// Prepare the query parameters
			let query_params = {};
			
			if (start > 0) {
				query_params.start = start;
			}
			
			if (has_url_field_filters) {
				query_params.field_filters = JSON.stringify(url_field_filters);
			}
			
			if (has_attribute_filters) {
				query_params.attribute_filters = JSON.stringify(this.attribute_filters);
			}
			
			if (has_price_filters) {
				query_params.price_range = JSON.stringify(this.price_range);
			}

			const query_string = this.get_query_string(query_params);
			window.history.pushState('filters', '', `${location.pathname}?` + query_string);
		}

		$('.page_content input').prop('disabled', true);

		this.make(true);
		$('.page_content input').prop('disabled', false);
	}

	restore_filters_state() {
		const filters = frappe.utils.get_query_params();
		//// Neoffice — price_range is restored from the URL like the other filters.
		let {field_filters, attribute_filters, price_range} = filters;
		
		// Track if we have any filters in URL
		const has_url_filters = field_filters || attribute_filters || price_range;

		if (field_filters) {
			field_filters = JSON.parse(field_filters);
			// Apply all filters from URL
			for (let fieldname in field_filters) {
				const values = field_filters[fieldname];
				const selector = values.map(value => {
					return `input[data-filter-name="${fieldname}"][data-filter-value="${value}"]`;
				}).join(',');
				$(selector).prop('checked', true);
			}
			this.field_filters = field_filters;
		}
		//// Neoffice — see above (restoring our own filters after a reload).
		
		// Always restore localStorage-managed filters regardless of URL filters
		// Stock filter
		const saved_stock_preference = webshop.filter_store.get('stock_filter_checked'); //// Neoffice — visit-scoped (webshop.filter_store, 2026-09-14)
		if (saved_stock_preference !== null) {
			const should_check_stock = saved_stock_preference === 'true';
			if (should_check_stock) {
				this.field_filters = this.field_filters || {};
				this.field_filters["in_stock"] = ["1"];
				$('#showInStockOnly').prop('checked', true);
			} else {
				$('#showInStockOnly').prop('checked', false);
			}
		} else if (!has_url_filters) {
			// Only use default if no saved preference and no URL filters
			const should_check_stock = this.stock_filter_default;
			if (should_check_stock) {
				this.field_filters = this.field_filters || {};
				this.field_filters["in_stock"] = ["1"];
				$('#showInStockOnly').prop('checked', true);
			} else {
				$('#showInStockOnly').prop('checked', false);
			}
		}
		
		// Discount filter - only update checkbox state, not filters
		const saved_discount_preference = webshop.filter_store.get('discount_filter_checked'); //// Neoffice — visit-scoped (webshop.filter_store, 2026-09-14)
		if (saved_discount_preference !== null) {
			const should_check_discount = saved_discount_preference === 'true';
			$('#showDiscountOnly').prop('checked', should_check_discount);
		} else {
			// No saved preference - ensure checkbox is unchecked by default
			$('#showDiscountOnly').prop('checked', false);
		}
		
		if (attribute_filters) {
			attribute_filters = JSON.parse(attribute_filters);
			for (let attribute in attribute_filters) {
				const values = attribute_filters[attribute];
				const selector = values.map(value => {
					return `input[data-attribute-name="${attribute}"][data-attribute-value="${value}"]`;
				}).join(',');
				$(selector).prop('checked', true);
			}
			this.attribute_filters = attribute_filters;
		}
		//// Neoffice — the stock/discount checkboxes are restored from localStorage, the
		//// rest from the URL.
		
		// Restore price filters state
		if (price_range) {
			try {
				const price_range_obj = JSON.parse(price_range);
				
				// Update the price_range object
				this.price_range = price_range_obj;
				
				// Update the input fields
				if (price_range_obj.min) {
					$('#price-min').val(price_range_obj.min);
				}
				
				if (price_range_obj.max) {
					$('#price-max').val(price_range_obj.max);
				}
				
				// Check the corresponding checkbox if it exists
				$('.price-filter').each(function() {
					const start_price = parseInt($(this).attr('data-start-price'));
					const end_price = parseInt($(this).attr('data-end-price'));
					
					if (start_price === price_range_obj.min && end_price === price_range_obj.max) {
						$(this).prop('checked', true);
					}
				});
			} catch (e) {
				console.error("Error restoring price filters:", e);
			}
		}
	}

	render_no_products_section(error=false) {
		//// Neoffice — the two messages below are translated through
		//// window.product_translations (dd08553e88, 2025-12-15).
		const translations = window.product_translations || {};
		//// Neoffice — translated error message (see above).
		let error_section = `
			<div class="mt-4 w-100 alert alert-error font-md">
				${ translations["Something went wrong. Please refresh or contact us."] || "Something went wrong. Please refresh or contact us." }
			</div>
		`;
		let no_results_section = `
			<div class="cart-empty frappe-card mt-4">
				<div class="cart-empty-state">
					<img src="/assets/webshop/images/cart-empty-state.png" alt="Empty Cart">
				</div>
				<div class="cart-empty-message mt-4">${ translations["No products found"] || "No products found" }</p>
			</div>
		`;

		this.products_section.append(error ? error_section : no_results_section);
	}

	render_item_sub_categories(categories) {
		//// Neoffice — drawn once. The page brings them (includes/sub_categories.html, #691 lot 2),
		//// and this ran on every result: each filter change added one more row of the same pills.
		if ($("#product-listing").children(".sub-category-container").length) return;
		if (categories && categories.length) {
			let sub_group_html = `
				<div class="sub-category-container scroll-categories">
			`;

			categories.forEach(category => {
				sub_group_html += `
					<a href="/${ category.route || '#' }" style="text-decoration: none;">
						<div class="category-pill">
							${ category.name }
						</div>
					</a>
				`;
			});
			sub_group_html += `</div>`;

			$("#product-listing").prepend(sub_group_html);
		}
	}

	get_query_string(object) {
		const url = new URLSearchParams();
		for (let key in object) {
			const value = object[key];
			if (value) {
				//// Neoffice — a filter value that is an object must be stringified before it goes
				//// into the query string, or the URL carried [object Object].
				// For JSON values, ensure they are properly stringified
				if (typeof value === 'object') {
					url.append(key, JSON.stringify(value));
				} else {
					url.append(key, value);
				}
			}
		}
		
		// Note: Do not add price_range here as it is already included in the params object
		// in the change_route_with_filters method
		
		return url.toString();
	}

	if_key_exists(obj) {
		let exists = false;
		for (let key in obj) {
			if (Object.prototype.hasOwnProperty.call(obj, key) && obj[key]) {
				exists = true;
				break;
			}
		}
		return exists ? obj : undefined;
	}
//// Neoffice — added, down to hide_product_loader at the end of the file. ▼▼▼
//// show_product_loader paints a SKELETON of cards in place of the list instead of
//// upstream's blanking: with the products kept visible during loading, an overlay
//// spinner made the page look frozen (567e038dd5, 2025-12-16 "always use skeleton
//// loading instead of overlay spinner"). ▲▲▲

	disable_view_toggler(disable) {
		$('#list').prop('disabled', disable);
		$('#grid').prop('disabled', disable);
	}
	
	show_product_loader() {
		// Determine view type from user preference
		const isGridView = this.preference === "Grid View";
		//// Neoffice — the server's cards are on screen (#691 lot 2): the areas are prepared,
		//// hidden, and no skeleton is drawn over the products (drop_ssr_listing shows the view).
		if (this.ssr_listing) {
			if (!$('#products-grid-area').length) {
				this.products_section.append(`
					<div id="products-list-area" class="row products-list mt-6 ml-2 hidden"></div>
					<div id="products-grid-area" class="row products-list mt-minus-1 hidden"></div>
				`);
			}
			this.add_product_loader_styles();
			return;
		}

		// Always use skeleton loading - provides better visual feedback than overlay spinner

		// First ensure the containers exist (only on initial load)
		if (!$('#products-grid-area').length) {
			//// Neoffice — no itemscope on the grid and the list: a list of products is not "a Product" (#691, D4).
			this.products_section.append(`
				<div id="products-list-area" class="row products-list mt-6 ml-2 ${!isGridView ? '' : 'hidden'}"></div>
				<div id="products-grid-area" class="row products-list mt-minus-1 ${isGridView ? '' : 'hidden'}"></div>
			`);
		}

		// Make sure the correct view is visible
		if (isGridView) {
			$('#products-list-area').addClass('hidden');
			$('#products-grid-area').removeClass('hidden');
		} else {
			$('#products-grid-area').addClass('hidden');
			$('#products-list-area').removeClass('hidden');
		}

		// Get the target container
		const targetContainer = isGridView ? $('#products-grid-area') : $('#products-list-area');

		// Clear existing content (only for initial skeleton load)
		targetContainer.empty();
		
		// Create skeleton loader HTML
		let skeletonItems = '';
		// Use the page length from settings or default values
		const itemCount = (this.settings && this.settings.products_per_page) || (isGridView ? 12 : 8);
		
		for (let i = 0; i < itemCount; i++) {
			if (isGridView) {
				// Grid skeleton
				//// Neoffice — the skeleton's columns are the tile's (four from 1200 px, two on
				//// a phone, product_card.html); upstream drew three of col-md-4 (2026-09-11).
				skeletonItems += `
					<div class="col-6 col-md-4 col-xl-3 item-card skeleton-item">
						<div class="card text-left">
							<div class="card-img-container">
								<div class="skeleton-img skeleton-loader"></div>
							</div>
							<div class="card-body text-left card-body-flex" style="width:100%">
								<div style="margin-top: 1rem;">
									<div class="skeleton-title skeleton-loader"></div>
								</div>
								<div class="skeleton-category skeleton-loader"></div>
								<div class="skeleton-price-row">
									<div class="skeleton-price skeleton-loader"></div>
								</div>
							</div>
						</div>
					</div>
				`;
			} else {
				// List skeleton
				skeletonItems += `
					<div class="row list-row w-100 mb-4 skeleton-item">
						<div class="col-2 border text-center rounded list-image" style="position: relative; overflow: hidden;">
							<div class="skeleton-img-list skeleton-loader"></div>
						</div>
						<div class="col-10 text-left">
							<div style="display: flex; margin-left: -15px;">
								<div class="col-8" style="margin-right: -15px;">
									<div class="skeleton-title skeleton-loader"></div>
								</div>
								<div class="col-4">
									<div class="skeleton-btn-list skeleton-loader"></div>
								</div>
							</div>
							<div class="skeleton-category skeleton-loader"></div>
							<div class="skeleton-price skeleton-loader"></div>
						</div>
					</div>
				`;
			}
		}
		
		// Add skeletons directly to the existing container
		targetContainer.html(skeletonItems);
		
		this.add_product_loader_styles();
	}

	//// Neoffice — the loader's styles on their own (#691 lot 2): they also give the product areas
	//// their 10px top margin, which the server's first page needs as much as the skeleton does —
	//// without them the grid slid 26px up under the toolbar.
	add_product_loader_styles() {
		// Add CSS if not already added
		if (!$('#skeleton-loader-styles').length) {
			$('head').append(`
				<style id="skeleton-loader-styles">
					/* Skeleton loader base styles */
					.skeleton-loader {
						background: linear-gradient(
							90deg,
							#f0f0f0 0%,
							#f8f8f8 50%,
							#f0f0f0 100%
						);
						background-size: 200% 100%;
						animation: skeleton-loading 1.5s ease-in-out infinite;
					}
					
					@keyframes skeleton-loading {
						0% {
							background-position: -200% 0;
						}
						100% {
							background-position: 200% 0;
						}
					}
					
					/* Grid skeleton styles */
					.skeleton-img {
						height: 200px;
						width: 100%;
						border-radius: 0;
					}
					
					.skeleton-title {
						height: 18px;
						width: 80%;
						margin-bottom: 8px;
						border-radius: 4px;
					}
					
					.skeleton-category {
						height: 14px;
						width: 50%;
						margin-bottom: 8px;
						border-radius: 4px;
					}
					
					.skeleton-price-row {
						margin-top: 16px;
					}
					
					.skeleton-price {
						height: 20px;
						width: 45%;
						border-radius: 4px;
						display: inline-block;
					}
					
					/* Match card styles */
					.product-loader .card {
						margin-bottom: 1rem;
						border: 1px solid rgba(0,0,0,.125);
						border-radius: 0.25rem;
					}
					
					.product-loader .card-body {
						padding: 1rem;
					}
					
					/* List skeleton styles */
					.skeleton-img-list {
						height: 100%;
						width: 100%;
						min-height: 120px;
						border-radius: 0.25rem;
					}
					
					.skeleton-btn-list {
						height: 30px;
						width: 135px;
						float: right;
						border-radius: 4px;
					}
					
					.list-row .skeleton-title {
						margin-bottom: 8px;
					}
					
					.list-row .skeleton-category {
						height: 14px;
						width: 40%;
						margin-bottom: 8px;
					}
					
					.list-row .skeleton-price {
						height: 20px;
						width: 30%;
					}
					
					/* Remove default card styles for skeleton */
					.skeleton-item .card {
						transition: none;
					}
					
					.skeleton-item .card:hover {
						transform: none;
						box-shadow: 0 1px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.24);
					}
					
					/* Position relative for products section */
					#products-grid-area, #products-list-area {
						margin-top: 10px;
						position: relative;
					}

					/* Loading overlay styles */
					.product-loading-overlay {
						position: absolute;
						top: 0;
						left: 0;
						right: 0;
						bottom: 0;
						background: rgba(255, 255, 255, 0.7);
						display: flex;
						justify-content: center;
						align-items: flex-start;
						padding-top: 100px;
						z-index: 100;
						min-height: 200px;
					}

					.loading-spinner {
						width: 40px;
						height: 40px;
						border: 3px solid #f3f3f3;
						border-top: 3px solid var(--primary-color, #171717);
						border-radius: 50%;
						animation: spin 1s linear infinite;
					}

					@keyframes spin {
						0% { transform: rotate(0deg); }
						100% { transform: rotate(360deg); }
					}
				</style>
			`);
		}
	}
	
	hide_product_loader() {
		// Remove all skeleton items
		$('.skeleton-item').remove();

		// Remove loading overlay
		$('.product-loading-overlay').remove();
		$('#products-grid-area, #products-list-area').css('position', '');

		// Also ensure both product areas are properly cleaned if no products will be shown
		if (!this.products || this.products.length === 0) {
			$('#products-grid-area').empty();
			$('#products-list-area').empty();
		}
	}
};
